import { processBetTicketBarcode } from "@tickets/helpers/processBarcode";
import { store } from "@app/dev/index/terminalApp";
import { AdminUserCommands } from "@app/dev/actions/terminal";

export function getTicketData(barcode) {
  return processBetTicketBarcode(barcode);
}

export const checkAdminBarcode = (barcode) =>
  store.dispatch(
    AdminUserCommands("checkByBarcode", {
      id: barcode,
    })
  );

// export async function getCashOutTicketData(barcode) {
//   const params = {
//     doc_id: parseInt(barcode.slice(1, barcode.length), 10),
//     token: getAuthData()?.token,
//   };
//   const response = await swarmRequest(params, 'check_terminal_tito_document');
//   if (response.status_code !== 0) {
//     return CashoutTicket(response, barcode);
//   }
//   return response.data;
// }
